module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "halfTitlePage",
    attrs: {
      "id": "htp01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }), _c('h2', {
    staticClass: "halfTitlePageTitle"
  }, [_c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes from the Universe")])])]), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d8ca65d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416594161_htp01.vue
// module id = 87
// module chunks = 0